import * as React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import Radium from 'radium';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { selectForOrder } from './actions';

@connect(null, { selectForOrder, push })
@Radium
export default class CategoryModal extends React.Component {
  static propTypes = {
    category: PropTypes.shape.isRequired,
    push: PropTypes.func.isRequired,
    selectForOrder: PropTypes.func.isRequired
  };

  renderWorkshop(workshop) {
    const { selectForOrder } = this.props;

    return (
      <div>
        <strong>{workshop.name}</strong>
        <div style={{ marginBottom: 10 }}>{workshop.annotation}</div>
        <Button bsStyle="primary" bsSize="sm" onClick={() => selectForOrder(workshop.id)}>
          <i className="fa fa-check">&nbsp;</i>
          Vybrat
        </Button>
      </div>
    );
  }

  render() {
    const { category, push } = this.props;

    if (!category) return null;

    return (
      <Modal show onHide={() => push('/objednavka/workshopy')}>
        <Modal.Header closeButton>
          <Modal.Title>{category.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          { category
            .workshops
            .map(this.renderWorkshop.bind(this))
            .reduce((prev, curr) => [prev, <hr />, curr])
          }
        </Modal.Body>
        <Modal.Footer>
          <Link to="/objednavka/workshopy" className="btn btn-default">
            Zavřít
          </Link>
        </Modal.Footer>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/order/modal.jsx